import React from 'react';
import { Layout } from 'antd';

const { Footer } = Layout;

const CustomFooter = () => {
	return (
		<Footer style={{ textAlign: 'center' }}>
			Getam ©{new Date().getFullYear()}
		</Footer>
	);
}

export default CustomFooter;